// extracted by mini-css-extract-plugin
export default {"root":"LinkPage_root__LcoIi"};